import distributionImg from '../assets/images/medi-licences/distribute-medical-devices.jpeg';
import wholesaleImg from '../assets/images/medi-licences/wholesale-medical-licence.jpeg';
import manufacturingImg from '../assets/images/medi-licences/manufacture-medical-devices.jpeg';

export interface Licence {
  id: "distribution" | "wholesale" | "manufacturing";
  title: string;
  /** Value stored on quote requests in Firestore — keep stable so existing quotes still match */
  quoteValue: string;
  /** Who the licence is for, in one line */
  audience: string;
  /** Short description for the homepage cards */
  summary: string;
  /** Detail bullets for the Services page */
  points: string[];
  img: string;
  imgAlt: string;
}

// Single source of truth for the three SAHPRA licences — used by the homepage,
// the Services page and the quote form.
export const licences: Licence[] = [
  {
    id: "distribution",
    title: "Medical Distribution Licence",
    quoteValue: "Medical Distribution Licence",
    audience: "For businesses that import, export or sell finished medical devices under their own name.",
    summary: "You are the legal entity accountable to SAHPRA for the performance, safety and quality of the devices you bring to market.",
    points: [
      "Covers the import, export and sale of medical devices in their finished form.",
      "Typically used by businesses trading under their own name.",
      "Makes you the legal entity accountable to SAHPRA for the performance, safety and quality of the devices.",
    ],
    img: distributionImg,
    imgAlt: "Sample SAHPRA licence to distribute medical devices",
  },
  {
    id: "wholesale",
    title: "Wholesale Licence",
    quoteValue: "Wholesale & Distribution Licence",
    audience: "For businesses that buy medical devices from manufacturers or distributors to resell.",
    summary: "Covers the storage, transportation and delivery of medical devices bought for resale.",
    points: [
      "Focuses on the storage, transportation and delivery of products.",
      "For wholesalers that acquire medical devices from a manufacturer or another distributor for resale.",
    ],
    img: wholesaleImg,
    imgAlt: "Sample SAHPRA licence to wholesale medical devices",
  },
  {
    id: "manufacturing",
    title: "Manufacturing Licence",
    quoteValue: "Manufacturing Licence",
    audience: "For companies producing medical devices in South Africa.",
    summary: "For businesses manufacturing medical devices in South Africa, with documentation support and compliance checks.",
    points: [
      "For businesses manufacturing medical devices in South Africa.",
      "Documentation support.",
      "Regulatory compliance checks.",
    ],
    img: manufacturingImg,
    imgAlt: "Sample SAHPRA licence to manufacture medical devices",
  },
];

/** Link to the quote form with this licence already selected */
export const quoteLink = (id: Licence["id"]) => `/quote?licence=${id}`;
